/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-no-bind */

import React, {useEffect, useState, useMemo} from "react";
import {Route} from "react-router-dom";

import PropTypes from "prop-types";
import {connect} from "react-redux";
import {
    getImageOptions,
    getPermissionOptions,
    getWidgetTypes,
    getOsPaths,
    getOsMap,
    getAllDashboards,
} from "../../../store/dashboard/dashboard-actions";
import {
    changeDashboardLibraryLayout,
    setDashboardLibraryFilters,
    resetDashboardLibraryFilters,
} from "../../../store/user/user-actions";
import Loader from "../../../components/common/loader/Loader";
import {Switch} from "react-router-dom";
import ProtectedRoute from "../../../components/common/ProtectedRoute";
import DashboardPage from "../dashboard-page/dashboard-page";
import DashboardLibrary from "../dashboard-library/DashboardLibrary";
import {getLatestViewInDashboards, getRunningDashboardId} from "../../../helpers/dashboard-helpers";
import "./dashboard-controller.scss";
import {LATEST_VIEW_DASHBOARD_LIBRARY} from "../../../helpers/constants";
import {DashboardNotFoundPage} from "../dashboard-not-found-page/DashboardNotFoundPage";

const DashboardController = ({
    getAllDashboards,
    getImageOptions,
    getPermissionOptions,
    getWidgetTypes,
    location,
    selectedOrganization,
    getOsPaths,
    getOsMap,
    resourcesLoaded,
    history,
    favoriteDashboards,
    queryParams,
    dashboardFiltersLoaded,
}) => {
    const [firstLoad, setFirstLoad] = useState(true);
    const dataLoaded = useMemo(() => !Object.values(resourcesLoaded).some((resource) => !resource));

    useEffect(() => {
        fetchInitData();
    }, []);

    useEffect(() => {
        if (!selectedOrganization) {
            return;
        }
        fetchInitData();
    }, [selectedOrganization]);

    useEffect(() => {
        if (!dataLoaded) {
            return;
        }
        navigateToDashboards();
    }, [dataLoaded, location]);

    useEffect(() => {
        if (!dashboardFiltersLoaded) {
            return;
        }
        getAllDashboards(queryParams);
    }, [queryParams, dashboardFiltersLoaded]);

    const navigateToDashboards = async () => {
        if (location.hash && !location.hash.toLowerCase().includes("/_s_/dashboard")) {
            setFirstLoad(false);
            return;
        }

        if (
            location.pathname !== "/dashboard" &&
            location.pathname !== "/dashboard/view/" &&
            location.pathname !== "/dashboard/edit/"
        ) {
            setFirstLoad(false);
            return;
        }

        if (!firstLoad) {
            history.push("/dashboard/library");
            return;
        }

        setFirstLoad(false);
        const latestView = getLatestViewInDashboards();

        if (location.pathname === "/dashboard/view/" || location.pathname === "/dashboard/edit/") {
            history.push("/dashboard/library");
            return;
        }

        if (latestView === LATEST_VIEW_DASHBOARD_LIBRARY) {
            history.push("/dashboard/library");
            return;
        }

        const runningDashboardId = await getRunningDashboardId(favoriteDashboards);
        if (!runningDashboardId) {
            history.push("/dashboard/library");
            return;
        }

        history.push(`/dashboard/view/${runningDashboardId}`);
    };

    const fetchInitData = () => {
        getImageOptions();
        getPermissionOptions();
        getWidgetTypes();
        getOsPaths();
        getOsMap();
    };

    const renderDashboardPage = ({match}) => (
        <DashboardPage key={match.url} id={match.params.id} history={history} />
    );

    const renderLibrary = () => <DashboardLibrary history={history} />;

    return (
        <>
            {!dataLoaded && <Loader />}
            {!firstLoad && (
                <Switch>
                    <ProtectedRoute
                        exact
                        path="/dashboard/new"
                        action="privateDashboardWrite"
                        renderer={renderDashboardPage}
                        redirectRoute="/dashboard/library"
                    />
                    <ProtectedRoute
                        exact
                        path="/dashboard/view/:id"
                        action="dashboardAccess"
                        renderer={renderDashboardPage}
                        redirectRoute="/dashboard/library"
                    />
                    <ProtectedRoute
                        exact
                        path="/dashboard/edit/:id"
                        action="privateDashboardWrite"
                        renderer={renderDashboardPage}
                        redirectRoute="/dashboard/library"
                    />
                    <ProtectedRoute
                        exact
                        path="/dashboard/library"
                        action="dashboardAccess"
                        renderer={renderLibrary}
                        redirectRoute="/dashboard/library"
                    />
                    <Route path="/*" component={DashboardNotFoundPage} />
                </Switch>
            )}
        </>
    );
};

DashboardController.propTypes = {
    getAllDashboards: PropTypes.func.isRequired,
    getImageOptions: PropTypes.func.isRequired,
    getPermissionOptions: PropTypes.func.isRequired,
    getWidgetTypes: PropTypes.func.isRequired,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    location: PropTypes.objectOf(PropTypes.any).isRequired,
    selectedOrganization: PropTypes.objectOf(PropTypes.any),
    getOsPaths: PropTypes.func.isRequired,
    getOsMap: PropTypes.func.isRequired,
    changeDashboardLibraryLayout: PropTypes.func.isRequired,
    isFetchingDashboards: PropTypes.bool.isRequired,
    resourcesLoaded: PropTypes.objectOf(PropTypes.bool).isRequired,
    favoriteDashboards: PropTypes.arrayOf(PropTypes.any).isRequired,
    setDashboardLibraryFilters: PropTypes.func.isRequired,
    resetDashboardLibraryFilters: PropTypes.func.isRequired,
    queryParams: PropTypes.objectOf(PropTypes.any),
};

DashboardController.defaultProps = {
    selectedOrganization: null,
    queryParams: {},
};

const mapStateToProps = ({
    dashboardReducer: {isFetchingDashboards, resourcesLoaded, favoriteDashboards},
    userReducer: {queryParams, dashboardFiltersLoaded, selectedOrganization},
}) => ({
    selectedOrganization,
    isFetchingDashboards,
    resourcesLoaded,
    favoriteDashboards,
    queryParams,
    dashboardFiltersLoaded,
});

const mapDispatchToProps = (dispatch) => ({
    getImageOptions: () => getImageOptions(dispatch),
    getPermissionOptions: () => getPermissionOptions(dispatch),
    getWidgetTypes: () => getWidgetTypes(dispatch),
    getAllDashboards: (query) => getAllDashboards(dispatch, query),
    getOsPaths: () => getOsPaths(dispatch),
    getOsMap: () => getOsMap(dispatch),
    changeDashboardLibraryLayout: (layout) => changeDashboardLibraryLayout(dispatch, layout),
    setDashboardLibraryFilters: (filtersData) => setDashboardLibraryFilters(dispatch, filtersData),
    resetDashboardLibraryFilters: () => resetDashboardLibraryFilters(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardController);
